import * as React from "react";
import { cn } from "@/lib/cn";

// Same Button API as web-client. Variants resolve to .btn-* primitives
// in app.css; sizes map to .btn-sm/.btn-lg.
type Variant = "primary" | "secondary" | "ghost" | "danger" | "buy" | "sell";
type Size = "sm" | "md" | "lg";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  loading?: boolean;
}

const variants: Record<Variant, string> = {
  primary: "btn-primary",
  secondary: "btn-ghost",
  ghost: "btn-ghost",
  danger: "btn-danger",
  buy: "btn-primary",
  sell: "btn-danger",
};

const sizes: Record<Size, string> = {
  sm: "btn-sm",
  md: "",
  lg: "btn-lg",
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  function Button(
    {
      variant = "primary",
      size = "md",
      loading,
      className,
      children,
      disabled,
      ...rest
    },
    ref,
  ) {
    return (
      <button
        ref={ref}
        disabled={disabled || loading}
        className={cn("btn", variants[variant], sizes[size], className)}
        {...rest}
      >
        {loading && (
          <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-current border-t-transparent" />
        )}
        {children}
      </button>
    );
  },
);
